module.exports = __webpack_public_path__ + "static/img/banner-02.414b113.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/banner-02.jpg
// module id = 7Kg0
// module chunks = 1